/**
 * «¿Sin ideas? Prueba un ejemplo»: bajo el título, escribe en la caja una
 * descripción de muestra; cada vez que se pulsa, la siguiente.
 *
 * Sustituye a la fila de ideas (tres pastillas con su etiqueta), que era otro
 * bloque entre el título y la caja. Las ideas son las mismas —las del negocio
 * que dijo en la bienvenida, o las generales—, pero ahora caben en un renglón
 * de texto que sólo usa quien no sabe por dónde empezar.
 */
import { useState } from 'react'
import { IconRefresh } from '@tabler/icons-react'
import { useI18n } from '../../lib/i18n'
import type { PromptIdea } from './PromptComposer'

export function IdeaShuffle({ ideas, onIdea, inBox = false }: {
  ideas: readonly PromptIdea[]
  onIdea: (prompt: string) => void
  /** Como una pastilla más de la fila de abajo de la caja, con textos cortos. */
  inBox?: boolean
}) {
  const { t } = useI18n()
  /* -1: todavía no se ha pedido ninguna. La vuelta gira el icono. */
  const [at, setAt] = useState(-1)
  if (!ideas.length) return null
  const next = () => {
    const index = (at + 1) % ideas.length
    setAt(index)
    onIdea(t(ideas[index]!.prompt))
  }
  return (
    <button type="button" className={inBox ? 'cwa-idea-shuffle is-in-box' : 'cwa-idea-shuffle'} onClick={next}>
      <span>{t(at < 0 ? (inBox ? 'cwa.ideaTryShort' : 'cwa.ideaTry') : 'cwa.ideaAnother')}</span>
      <IconRefresh key={at} size={13} stroke={2.2} aria-hidden="true" className={at >= 0 ? 'is-spun' : undefined} />
    </button>
  )
}
